// These are the components that can be referenced
// in the CMS on certain templates as "Content Components".
// This allows a simple template to take on many forms as needed.
// For example, each contact form is a Content Component that can be
// used with feature-page without making a different template
// for each form.

import ProviderForm from "./forms/ProviderContactForm";
import PharmacyForm from "./forms/PharmacyContactForm";
import EOYBlogPost2020Template from "./special/EOYBlogPost2020";

export const ProviderContactForm = ProviderForm;
export const PharmacyContactForm = PharmacyForm;
export const EOYBlogPost2020 = EOYBlogPost2020Template;
